// eslint-disable-next-line import/prefer-default-export
export const isMobilePlatform = () =>
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/iPod/i);
